import React, { useEffect } from "react";
import styled from "styled-components";
import QueryEditModeContext from "views/components/contexts/QueryEditModeContext";
import useUndeclaredParameters from "enterprise/parameters/components/useUndeclaredParameters";
import ParameterBar from "./ParameterBar";
const CenteringContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const CenteredBox = styled.div`
  position: absolute;
  background: white;
  z-index: 1;
  left: 0;
  right: 0;
  width: max-content;
  margin: 0 auto;
`;
const UndeclaredParameterAlert = ({ retry }) => {
  const undeclaredParameterNames = useUndeclaredParameters();
  if (undeclaredParameterNames.size === 0) {
    retry();
    return null;
  }
  return /* @__PURE__ */ React.createElement(QueryEditModeContext.Provider, { value: "widget" }, /* @__PURE__ */ React.createElement(CenteringContainer, null, /* @__PURE__ */ React.createElement(CenteredBox, null, /* @__PURE__ */ React.createElement(ParameterBar, null))));
};
const WidgetEditModeParameterBar = ({ override }) => {
  const undeclaredParameterNames = useUndeclaredParameters();
  useEffect(() => {
    if (undeclaredParameterNames.size > 0) {
      override(UndeclaredParameterAlert);
    }
  }, [override, undeclaredParameterNames]);
  return null;
};
export default WidgetEditModeParameterBar;
